export default __webpack_public_path__ + "static/media/asana.873308df.svg";